import useReveal from "@/hooks/useReveal";
import Hero from "@/components/site/Hero";
import Features from "@/components/site/Features";
import RoleSwitch from "@/components/site/RoleSwitch";
import HowItWorks from "@/components/site/HowItWorks";
import QRSection from "@/components/site/QRSection";
import FAQ from "@/components/site/FAQ";
import PopularRoutes from "@/components/site/PopularRoutes";
import { Link } from "react-router-dom";

export default function LandingPage() {
  const ref = useReveal();
  return (
    <main ref={ref}>
      <Hero />
      <RoleSwitch />
      <PopularRoutes />
      <Features />
      <HowItWorks />
      <QRSection />

      {/* Mid-page CTA */}
      <section
        data-testid="mid-cta"
        className="relative py-24 border-t border-[#e5e7eb] bg-[#F9FAFB]"
      >
        <div className="mx-auto max-w-5xl px-6 lg:px-10 text-center reveal">
          <h2 className="font-display text-4xl md:text-6xl font-black tracking-[-0.03em] leading-tight text-[#24303F]">
            Be one of the <span className="text-[#5FA836]">first 100</span>.
          </h2>
          <p className="mt-5 font-body text-gray-600 text-base md:text-lg max-w-2xl mx-auto">
            Lock in your ₹100 cashback. Get launch-day access. Help shape the
            future of pool sharing in India.
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <a
              href="#waitlist"
              data-testid="mid-cta-join"
              className="btn-primary rounded-full px-7 py-3 font-display"
            >
              Join the waitlist
            </a>
            <Link
              to="/about"
              data-testid="mid-cta-about"
              className="btn-ghost rounded-full px-7 py-3 font-display"
            >
              Learn more
            </Link>
          </div>
        </div>
      </section>

      <FAQ />
    </main>
  );
}
